import React from "react";
import BestsellerCarousel from "../components/BestsellerCarousel";
import CatalogGrid from "../components/CatalogGrid";
import CreditSimulator from "../components/CreditSimulator";

export default function Home() {
  return (
    <div data-testid="page-home">
      {/* Slim intro strip */}
      <section className="bg-gradient-to-br from-[#002d62] to-[#001a3f] text-white">
        <div className="y-container py-5 sm:py-6">
          <p className="text-[10px] sm:text-xs uppercase tracking-widest text-white/60 font-semibold">
            Sales Motor Yamaha · Kalimantan Barat
          </p>
          <h1 className="mt-1 font-display font-extrabold text-xl sm:text-3xl leading-tight">
            Katalog Resmi Motor <span className="text-[#ffb020]">Yamaha</span>
          </h1>
          <p className="text-white/70 text-xs sm:text-sm mt-1 max-w-xl">
            Harga OTR terbaru, gambar & data lengkap dari Yamaha Indonesia. Pesan langsung via WhatsApp.
          </p>
        </div>
      </section>

      <BestsellerCarousel />
      <CatalogGrid />
      <CreditSimulator />
    </div>
  );
}
